import {defineMessages} from 'react-intl';

const messages = defineMessages({
    variable: {
        defaultMessage: 'my variable',
        description: 'Name for the default variable',
        id: 'gui.defaultProject.variable'
    }
});

// use the default message if a translation function is not passed
const defaultTranslator = msgObj => msgObj.defaultMessage;

/**
 * Generate a localized version of the default project
 * @param {function} translateFunction a function to use for translating the default names
 * @return {object} the project data json for the default project
 */
const projectData = translateFunction => {
    const translator = translateFunction || defaultTranslator;
    return ({
        targets: [
            {
                isStage: true,
                name: 'Stage',
                variables: {
                    '`jEk@4|i[#Fk?(8x)AV.-my variable': [
                        translator(messages.variable),
                        0
                    ]
                },
                lists: {},
                broadcasts: {},
                blocks: {},
                currentCostume: 0,
                costumes: [
                    {
                        assetId: 'cd21514d0531fdffb22204e0ec5ed84a',
                        name: '背景1',
                        md5ext: 'cd21514d0531fdffb22204e0ec5ed84a.svg',
                        dataFormat: 'svg',
                        rotationCenterX: 240,
                        rotationCenterY: 180
                    }
                ],
                sounds: [
                    {
                        assetId: '83a9787d4cb6f3b7632b4ddfebf74367',
                        name: 'pop',
                        dataFormat: 'wav',
                        format: '',
                        rate: 48000,
                        sampleCount: 1123,
                        md5ext: '83a9787d4cb6f3b7632b4ddfebf74367.wav'
                    }
                ],
                volume: 100
            },
            {
                isStage: false,
                name: 'ペンギン',
                variables: {},
                lists: {},
                broadcasts: {},
                blocks: {},
                currentCostume: 0,
                costumes: [
                    {
                        assetId: 'f937aca97db0318f28ac08a2f9af5c43',
                        name: 'ペンギン-a',
                        bitmapResolution: 1,
                        md5ext: 'f937aca97db0318f28ac08a2f9af5c43.svg',
                        dataFormat: 'svg',
                        rotationCenterX: 211,
                        rotationCenterY: 211
                    },
                    {
                        assetId: '6ceb2338036c684fda4a7809a6d38953',
                        name: 'ペンギン-b',
                        bitmapResolution: 1,
                        md5ext: '6ceb2338036c684fda4a7809a6d38953.svg',
                        dataFormat: 'svg',
                        rotationCenterX: 211,
                        rotationCenterY: 211
                    },
                    {
                        assetId: '571a612ea1427b8aef220d0e59bff768',
                        name: 'ペンギン-c',
                        bitmapResolution: 1,
                        md5ext: '571a612ea1427b8aef220d0e59bff768.svg',
                        dataFormat: 'svg',
                        rotationCenterX: 211,
                        rotationCenterY: 211
                    }
                ],
                sounds: [
                    {
                        assetId: '8c4799b3173e3fcb9588fde5fcdc26a3',
                        name: 'アカショウビンの鳴き声',
                        dataFormat: 'wav',
                        format: '',
                        rate: 48000,
                        sampleCount: 85559,
                        md5ext: '8c4799b3173e3fcb9588fde5fcdc26a3.wav'
                    }
                ],
                volume: 100,
                visible: true,
                x: 0,
                y: 0,
                size: 25,
                direction: 90,
                draggable: false,
                rotationStyle: 'all around'
            }
        ],
        meta: {
            semver: '3.0.0',
            vm: '0.1.0',
            agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/65.0.3325.181 Safari/537.36' // eslint-disable-line max-len
        }
    });
};


export default projectData;
